<template>
  <ul class="interest-links">
    <li v-for="link in links" :key="links.indexOf(link)" :class="size">
      <a :href="link.href" target="_blank">
        <font-awesome-icon
          :icon="[link.iconType, link.icon]"
          data-aos="zoom-in"
          data-aos-duration="500"
          :data-aos-delay="link.delay"
        ></font-awesome-icon>
        <p>{{ link.text }}</p>
      </a>
    </li>
  </ul>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'LinksInterest',
  components: {
    FontAwesomeIcon,
  },
  props: {
    size: String,
  },
  data() {
    return {
      links: [
        {
          text: 'Servicio Nacional de Migración',
          href: 'https://www.migracion.gob.pa/',
          icon: 'suitcase-rolling',
          iconType: 'fas',
          delay: 200,
        },
        {
          text: 'Ministerio Público',
          href: 'http://ministeriopublico.gob.pa/',
          icon: 'user-tie',
          iconType: 'fas',
          delay: 400,
        },
        {
          text: 'Órgano Judicial',
          href: 'https://www.organojudicial.gob.pa/',
          icon: 'gavel',
          iconType: 'fas',
          delay: 600,
        },
        {
          text: 'Panamá Compras',
          href: 'http://www.panamacompra.gob.pa/Inicio/#!/',
          icon: 'shopping-cart',
          iconType: 'fas',
          delay: 800,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
ul.interest-links {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 40px);
  margin: 0 20px;
  padding: 0;

  li {
    list-style: none;
    text-align: center;
    margin: 20px;
    padding: 10px;

    &.quarter {
      width: calc(25% - 60px);
    }

    &.half {
      width: calc(50% - 60px);
    }

    a {
      text-decoration: none;

      p {
        font-family: "Lucida Grande", Tahoma;
        font-size: 1em;
        font-weight: lighter;
        font-variant: normal;
        text-transform: uppercase;
        color: #fff;
        letter-spacing: 0.2em;
        margin-top: 10px;
      }

      svg {
        color: #76665b; // #666
        font-size: 2.5em;
      }
    }
  }
}
</style>
